import React from "react"
import './Loader.css'

const Loader = () => {
    return(
        <div className="divloader">
            <div className="loading"></div>
        </div>
    )
}

export default Loader